import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import React from "react";
import { AppButton, IAppButtonProps } from "ui/Scripts/source/components/framework/Button/AppButton";

export const ConfirmationButton = (props: IAppButtonProps) => (
    <AppButton variant="contained" startIcon={<CheckCircleOutlinedIcon />} {...props}>
        {props.children}
    </AppButton>
);
